// ignore-string-externalization

import React from 'react';
import styled from 'styled-components';
import {
  screenMdMin,
  spacer16,
  heading1FontSizeXSmall,
  IconArrowRight,
  Type,
} from '@spotify-internal/encore-web';

import { hexToRgba } from '../../../../features/src/color-conversion';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { ContentfulAsset } from '../../Contentful';
import {
  ButtonTertiaryAsLink,
  DELAYS,
  fadeInAnimation,
  ImageAspectBox1x1,
  withAnimationContext,
} from '../../ui';
import { fixHref } from '../../utils';

type ThreeUpSegmentType = {
  headline?: string;
  body?: string;
  linkText?: string;
  linkUrl?: string;
  image?: ContentfulAsset;
};

const Segment = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const ImageBox = styled(ImageAspectBox1x1)`
  width: 100%;
  padding: 0px ${spacer16};

  @media (max-width: ${screenMdMin}) {
    width: 60%;
    align-self: center;
  }
`;

const Headline = withAnimationContext(
  styled(Type.h1).attrs({
    paddingBottom: '0.75em',
    variant: 'alto',
    weight: 'bold',
  })`
    ${fadeInAnimation(DELAYS.THIRD)};
    font-size: ${heading1FontSizeXSmall};
    padding-top: ${spacer16};
    padding-bottom: ${spacer16};

    @media (max-width: ${screenMdMin}) {
      padding-top: ${spacer16};
    }
  `,
);

const SegmentTextLink = styled(ButtonTertiaryAsLink)`
  text-align: center;

  color: ${({ theme }) => theme.box.text};
  &:hover:not(:focus):not(:disabled) {
    color: ${({ theme }) => hexToRgba(theme.box.text, 0.5)};
  }
`;

const BodySection = withAnimationContext(
  styled(Type.p).attrs({
    variant: 'ballad',
  })`
    ${fadeInAnimation(DELAYS.FOURTH)};
  `,
);

type ThreeUpSegmentParams = {
  threeUpSegment: ThreeUpSegmentType;
};

const TRACK_CAT = 'module-featuredContent3Up';

export const ThreeUpSegment: React.FC<ThreeUpSegmentParams> = ({
  threeUpSegment = {},
}) => {
  return (
    <Segment>
      {threeUpSegment.image && (
        <ImageBox>
          <ContentfulImage asset={threeUpSegment.image} />
        </ImageBox>
      )}
      <Headline>{threeUpSegment.headline}</Headline>
      <BodySection>{threeUpSegment.body}</BodySection>
      {threeUpSegment.linkText && threeUpSegment.linkUrl && (
        <SegmentTextLink
          href={fixHref(threeUpSegment.linkUrl)}
          track={[TRACK_CAT, `Link - ${threeUpSegment.linkText}`]}
          iconTrailing={() => <IconArrowRight iconSize={16} />}
          condensed
        >
          {threeUpSegment.linkText}
        </SegmentTextLink>
      )}
    </Segment>
  );
};
